import { Component, OnDestroy, OnInit } from "@angular/core";
import { AuthService } from 'src/app/services/auth.service';
import { LoginModel } from 'src/app/models/login.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: "app-logo",
  templateUrl: "./logo.component.html",
  styleUrls: ["./logo.component.scss"],
})
export class LogoComponent implements OnInit,OnDestroy {
  userInfo: LoginModel;
  private destroy$ = new Subject<void>();
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.userInfo$
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => (this.userInfo = res));
   }
  
  getRoute = () => {
    this.authService.redirectRouteOnLoad(this.userInfo);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
